import React from "react";
import StandardModal from "./shared/StandardModal";
import PropTypes from "prop-types";
import { ClassroomToolsContext } from "./RegularClassroom";
import { RestrictedWebsiteOrAppItem } from "./RestrictedWebsiteOrAppItem";
import { WebsiteListItem } from "./WebsiteListItem";
import useStore from "stores/index";
import { getFeatures } from "stores/classwizeConfigStore";

export default class WebsiteOrSignatureListModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			blockUserOpen: false,
			newPolicyTag: undefined,
			newPolicyWebsite: undefined,
			features: getFeatures(useStore.getState()) || [],
		};
	}

	handleClose = () => {
		this.props.onClose();
	};

	openRuleModal = (commonComponent) => {
		this.context.openRuleModal(false, commonComponent.url, commonComponent.id, this.props.user.username);
	};

	renderItems = () => {
		const ret = [];
		if (this.props.isRestricted) {
			if (this.props.items) {
				for (const item of this.props.items) {
					const modalItem = {
						title: item.name ? item.name : item.title,
						id: item.id ? item.id : undefined,
						url: item.url ? item.url : item.tabUrl,
					};
					ret.push(
						<RestrictedWebsiteOrAppItem
							key={`${item.tab_id}`}
							itemKey={ret.length}
							item={item}
							modalItem={modalItem}
							handleOpenRuleModal={this.openRuleModal}
							canCloseTab={this.props.canCloseTab}
							forceCloseTab={this.props.forceCloseTab}
							classIsActive={this.props.classIsActive}
							isMonitorMode={this.props.isMonitorMode}
							canCreateRule={this.state.features.includes("policies")}
						/>
					);
				}
			}
		} else {
			if (this.props.activeTab) {
				ret.push(
					<WebsiteListItem
						key={`${this.props.activeTab.tab_id}`}
						itemKey={ret.length}
						item={this.props.activeTab}
						comComponent={this.props.activeTab}
						handleOpenRuleModal={this.openRuleModal}
						canCloseTab={this.props.canCloseTab}
						forceCloseTab={this.props.forceCloseTab}
						classIsActive={this.props.classIsActive}
						isActiveTab={true}
						isMonitorMode={this.props.isMonitorMode}
						canCreateRule={this.state.features.includes("policies")}
					/>
				);
			}

			if (this.props.items) {
				for (const item of this.props.items) {
					const comComponent = {
						title: item.name ? item.name : item.title,
						id: item.id ? item.id : undefined,
						url: item.url ? item.url : item.tabUrl,
					};
					ret.push(
						<WebsiteListItem
							key={`${item.tab_id}`}
							itemKey={ret.length}
							item={item}
							comComponent={comComponent}
							handleOpenRuleModal={this.openRuleModal}
							canCloseTab={this.props.canCloseTab}
							forceCloseTab={this.props.forceCloseTab}
							classIsActive={this.props.classIsActive}
							isMonitorMode={this.props.isMonitorMode}
							canCreateRule={this.state.features.includes("policies")}
						/>
					);
				}
			}
		}
		return ret;
	};

	render() {
		return (
			<React.Fragment>
				<StandardModal
					size="medium"
					contentClassName="WebsiteOrSignatureListModal_content"
					title={this.props.title}
					close={this.handleClose}
					open={this.props.open}
				>
					<div>{this.renderItems()}</div>
				</StandardModal>
			</React.Fragment>
		);
	}
}

WebsiteOrSignatureListModal.propTypes = {
	title: PropTypes.string,
	items: PropTypes.arrayOf(PropTypes.object),
	activeTab: PropTypes.object,
	user: PropTypes.object,
	open: PropTypes.bool,
	canCloseTab: PropTypes.bool,
	classIsActive: PropTypes.bool,
	isMonitorMode: PropTypes.bool,
	forceCloseTab: PropTypes.func,
	onClose: PropTypes.func,
	isRestricted: PropTypes.bool,
};

WebsiteOrSignatureListModal.contextType = ClassroomToolsContext;
